import React, { Component } from 'react'
import ViewCategoryTab from './view'
import Create from './create'
import EditCategory from './edit'

export default class CategoryTab extends Component {
    state = {
        page:'view',
        id_category: null
    }

    handlePage = page => {
        this.setState({page})
    }

    handleCategory = id =>{
        this.setState({
            id_category: id,
            page: 'edit'
        })
    }

    render() {
        return (
            <div>
                {this.state.page === 'view' && <ViewCategoryTab handlePage = { this.handlePage } handleCategory = {this.handleCategory} />}
                {this.state.page === 'create' && <Create handlePage = { this.handlePage } />}
                {this.state.page === 'edit' && <EditCategory id_category={this.state.id_category}  handlePage={this.handlePage}/>}
            </div>
            // this.state.page === 'view' ? <ViewCategoryTab handlePage = { this.handlePage } /> : <Create handlePage = { this.handlePage } />
        )
    }
}
